export const REQUESTED_MAX_STORAGE_BUFFERS_PER_SHADER_STAGE = 10;

